import React from 'react';

import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import Typography from '../Typography/Typography';

const useStyles = makeStyles({
  root: {
    // width: '362px',
    width: '20vw',
    // alignItems: 'center',
    // marginRight: '2%',
    // marginLeft: '2%',
    '@media only screen and (max-width: 768px)': {
      width: '60vw',
    },
  },
  month: {
    backgroundColor: 'black',
    color: 'white',
    textAlign: 'center',
  },

  //가로크기
  image: {
    width: '20vw',
    '@media only screen and (max-width: 768px)': {
      width: '60vw',
    },
  },
  textBox: {
    marginTop: '18px',
    textAlign: 'center',
  },
  textTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    letterSpacing: '-0 18px',
    textAlign: 'center',
    color: '#191919',
    marginBottom: '8px',
    '@media only screen and (max-width: 768px)': {
      fontSize: '14px',
      marginBottom: '16px',
    },
  },
  textRedTitle: {
    fontSize: '18px',
    fontFamily: 'Pretendard',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#db350f',
    marginBottom: '8px',
  },
  text: {
    fontFamily: 'Pretendard',
    fontSize: '16px',
    lineHeight: 1.25,
    letterSpacing: '-0.16px',
    textAlign: ' center',
    color: '#191919',
    marginBottom: '20px',
    '@media only screen and (max-width: 768px)': {
      fontSize: '12px',
      marginBottom: '14px',
    },
  },
});

export default function Plancard(props) {
  const { data } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.month}>
        <Typography>{data.month}</Typography>
      </Box>
      <Box>
        <img className={classes.image} alt='plancard' src={data.ImageSrc} />
      </Box>
      <Box className={classes.textBox}>
        <Typography className={classes.textRedTitle}>{data.redtitle}</Typography>
        <Typography className={classes.textTitle}>{data.title}</Typography>
        {data.text.map((t, i) => {
          return (
            <Box key={i}>
              <Typography className={classes.text}>{t.line}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
